/** Traductions modal brouillons POS (FR / AR) */
export const draftsModalFr = {
  now: 'Maintenant',
  hoursAgo: 'Il y a {{count}}h',
  daysAgo: 'Il y a {{count}}j',
  customerUnknown: 'Client sans informations',
  title: 'Brouillons',
  subtitle: '{{count}} brouillon',
  subtitlePlural: '{{count}} brouillons',
  hint: 'Charger remet le panier. Supprimer retire le brouillon.',
  close: 'Fermer',
  emptyTitle: 'Aucun brouillon',
  emptyText: 'Enregistrez un panier avec « Brouillon » pour le retrouver ici.',
  itemsCount: '{{count}} ligne',
  itemsCountPlural: '{{count}} lignes',
  itemsMore: 'et {{count}} autre…',
  itemsMorePlural: 'et {{count}} autres…',
  unitsCount: '{{count}} unités',
  totalLabel: 'Total',
  load: 'Charger',
  loadAria: 'Charger le brouillon de {{customer}}',
  delete: 'Supprimer',
  deleteAria: 'Supprimer le brouillon de {{customer}}',
  deliveryBadge: 'Livraison',
  markDelivered: 'Livré'
};

export const draftsModalAr = {
  now: 'الآن',
  hoursAgo: 'منذ {{count}} ساعة',
  daysAgo: 'منذ {{count}} يوم',
  customerUnknown: 'عميل بدون معلومات',
  title: 'المسودات',
  subtitle: '{{count}} مسودة',
  subtitlePlural: '{{count}} مسودة',
  hint: 'التحميل يستعيد السلة. الحذف يزيل المسودة.',
  close: 'إغلاق',
  emptyTitle: 'لا توجد مسودات',
  emptyText: 'احفظ السلة عبر « مسودة » لتظهر هنا.',
  itemsCount: '{{count}} بند',
  itemsCountPlural: '{{count}} بنود',
  itemsMore: 'و {{count}} آخر…',
  itemsMorePlural: 'و {{count}} أخرى…',
  unitsCount: '{{count}} وحدة',
  totalLabel: 'المجموع',
  load: 'تحميل',
  loadAria: 'تحميل مسودة {{customer}}',
  delete: 'حذف',
  deleteAria: 'حذف مسودة {{customer}}',
  deliveryBadge: 'توصيل',
  markDelivered: 'تم التوصيل'
};
